export const caseVersion = '0.30.1'; // x-release-please-version
